import React,{useState} from 'react';
import MessageA5 from './MessageA5';



const MessageA23 = (props) => {
    const [value,setValue] =useState(-1)
   
    const listData = JSON.parse(props.item.text);
    // console.log("listbuttonprops",props,listData)

    return(
        <div>
             {listData.data &&  listData.data.map(data => (
             <><span className="chat-label action-tab" id="main-tab1" style={{color:data.disabled && 'grey'}} onClick={(e)=>{
               props.handleClick(props.item.code,data.value); props.setTextOnClick(data.name) }}>{data.name}</span></>
             ) )} </div>
    )
}


export default MessageA23;